import type { KnowledgeBase } from '@mint-sdk/api-ai-assistant';

export type FolderAccessUser = Pick<
  KnowledgeBase.WorkspaceUser,
  'firstName' | 'lastName' | 'email'
>;

export const toUserName = ({
  firstName,
  lastName,
}: Pick<FolderAccessUser, 'firstName' | 'lastName'>): string =>
  [firstName, lastName].filter(Boolean).join(' ');
